import { IoMdCheckmarkCircleOutline, IoMdCloseCircleOutline } from 'react-icons/io';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
	setBillingType,
	setPlan,
} from '../../../store/reducers/subscriptionSlice/subscriptionSlice';

const PricingCard = ({ plan, billing, onOpenFreeModal }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const selectedBilling = plan?.billing?.find((item) => item.period === billing);

	const buttonText =
		plan?.key === 'professional'
			? 'Go Professional'
			: plan?.key === 'enterprise'
				? 'Go Enterprise'
				: 'Get Started';

	const handleSelectPlan = async () => {
		try {
			if (plan?.key?.includes('free')) {
				onOpenFreeModal(plan);
				return;
			} else {
				// const monthlyPlan = plan?.billing?.find((item) => item?.period === 'monthly');
				// const yearlyPlan = plan?.billing?.find((item) => item?.period === 'yearly');

				// const payload = {
				// 	id: plan?._id,
				// 	key: plan?.key,
				// 	title: plan?.name,
				// 	description: plan?.meta?.description,
				// 	monthly_price: monthlyPlan?.amount_in_rupees || 0,
				// 	yearly_price: yearlyPlan?.amount_in_rupees || 0,
				// 	currency: selectedBilling?.currency,
				// 	billingPeriod: billing,
				// 	razorpay_plan_id: selectedBilling?.razorpay_plan_id,
				// 	isRecurring: true,
				// };
				const payload = {
					id: plan?._id,
					key: plan?.key,
					title: plan?.name,
					description: plan?.meta?.description,
					billing: plan?.billing || [],
				};

				dispatch(setPlan(payload));
				dispatch(setBillingType(billing));
				navigate(`/checkout?plan=${plan.key}&billing=${billing}&step=billing-details`);
			}
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<div className="pricing-card">
			<h5 className="title">{plan?.name}</h5>

			<p className="desc">{plan?.meta?.description}</p>

			<div className="price">
				{plan?.custom ? (
					<p className="contact">Contact Us</p>
				) : (
					<div className="price-main">
						<span className="currency">₹</span>
						<span className="amount">{selectedBilling?.amount_in_rupees ?? 0}</span>
						<span className="duration">/{billing === 'monthly' ? 'Month' : 'Year'}</span>
					</div>
				)}
			</div>
			<div className="features-wrapper">
				<ul className="features">
					{plan?.display_features?.map((item, i) => {
						// handle both string and object format
						const isObject = typeof item === 'object' && item !== null;
						const label = isObject ? item.label : item;
						const display = isObject ? item.display : null;
						const available = isObject ? item.available : true;

						return (
							<li
								key={i}
								style={{ opacity: available ? 1 : 0.5 }}
							>
								{available ? (
									<IoMdCheckmarkCircleOutline
										className="icon"
										style={{ color: '#68C230' }}
									/>
								) : (
									<IoMdCloseCircleOutline
										className="icon"
										style={{ color: '#dc3545' }}
									/>
								)}
								<span>
									{
										display && display !== '✓' && display !== '✗'
											? `${display} ${label}` // "20 Orders / Month"
											: label // "Watermark"
									}
								</span>
							</li>
						);
					})}
				</ul>
			</div>
			<div className="btn-group-custom">
				<button
					onClick={handleSelectPlan}
					className="btn btn-primary mt-0 w-100"
				>
					{buttonText}
				</button>

				<Link
					to="https://pharmnex-app.vercel.app/pricing"
					className="btn btn-primary w-100 mt-0"
				>
					Learn More
				</Link>
			</div>
		</div>
	);
};

export default PricingCard;
